import { render } from "./NewPlantPage.vue?vue&type=template&id=f485f904&ts=true"
import script from "./NewPlantPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewPlantPage.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/Users/voquanghoa/code/medicinal-plant/MedicinalPlant.Frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/NewPlantPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f485f904"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f485f904', __exports__)) {
    api.reload('f485f904', __exports__)
  }
  
  module.hot.accept("./NewPlantPage.vue?vue&type=template&id=f485f904&ts=true", () => {
    api.rerender('f485f904', render)
  })

}


export default __exports__